import { useBooleanState } from '@cian/react-utils';
import { ModalWindow, UIText1 } from '@cian/ui-kit';

import { type FC, useState } from 'react';

import { type TOnlinePurchase, onlinePurchase } from 'shared/settings/onlinePurchase';
import { type IPurchase } from 'shared/types/purchase';

import { PurchaseLayout } from './components/PurchaseLayout';
import { PurchaseList } from './components/PurchaseList';

export const PurchaseContainer: FC = () => {
  const { state: open, setTrue: setOpen, setFalse: setClose } = useBooleanState();
  const [content, setContent] = useState<TOnlinePurchase['algorithm'][number]>(onlinePurchase.algorithm[0]);

  const openModal = (item: IPurchase): void => {
    setContent(item);
    setOpen();
  };

  return (
    <>
      <PurchaseLayout
        list={<PurchaseList list={onlinePurchase.algorithm} onOpenModal={openModal} />}
        title={onlinePurchase.title}
      />

      <ModalWindow
        content={<UIText1>{content.text}</UIText1>}
        fixed={false}
        maxWidth={472}
        open={open}
        outside={true}
        title={content.title}
        onClose={setClose}
      />
    </>
  );
};
